var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline-item',{attrs:{"color":_vm.color,"fill-dot":_vm.fillDot,"icon":_vm.icon,"icon-color":_vm.iconColor}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }